import { render } from "./Create.vue?vue&type=template&id=61d2807c"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PurchaseReqs/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61d2807c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61d2807c', __exports__)) {
    console.log('reload')
    api.reload('61d2807c', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=61d2807c", () => {
    console.log('re-render')
    api.rerender('61d2807c', render)
  })

}


export default __exports__